import MegaMenu from '../__header/MegaMenu';
import MegaMenuGhost from '../__header/MegaMenuGhost';
import LiveSearch from '../__header/LiveSearch';
import MobileHeader from '../__header/mobileHeader';
import toggleAlertBar from '../__header/AlertBar';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import checkAnchorsOnLoad from '../__utils/smoothScrollOnLoad';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import vhUnit from '../__utils/vhUnit';
import sectionsInView from "../__utils/sectionsInView";
const headerMobile = new MobileHeader();

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
		MegaMenuGhost();
        MegaMenu.init();
		LiveSearch();
        headerMobile.init();
		toggleAlertBar();
        Accordion.init();
        Video.init();
        mirrorHover();
        smoothScroll();
        Tables.init();
        vhUnit();
		sectionsInView();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        Forms();
        vhUnit();
        checkAnchorsOnLoad();
    },
    resized() {
        headerMobile.resized();
        Tables.toggleShadow();
        vhUnit();
    },
    scrolled() {
		MegaMenuGhost();
    },
    keyDown(e){

    },
    mouseUp(e) {
        headerMobile.hideOutsideClick(e);
    },
};
export default controller;
